export default {
  certificateLoading: (state) => state.certificateLoading,
  certificateContent: (state) => state.certificateContent,
  certificateVerificationContent: (state) => state.certificateVerificationContent,
  certificateVerificationLoading: (state) => state.certificateVerificationLoading,
  certificateVerificationLink: (state) => state.certificateVerificationLink,
};
